import React, { useEffect, useMemo, useState, useContext } from "react";
import StoreContext from "./../Componentes/Store/Context";
import "./../Componentes/www/pos-restaurante.css";
import { FOOTER_FACTURA_RESTAURANTE } from "./Util";
import { IconButton } from "@mui/material";
import { IconCheck, AmpliarDiv, IconChef, SaveIcon, IconReceipt, IconSearch, IconUtensils, InvoiceIcon, ReloadIcon, IconClock, Trash2Icon } from "./www/Icons";
import { MDBIcon } from "mdb-react-ui-kit";
import { Col, Row } from "reactstrap";
import { COCINA_DEFAULT, EXIT_IMAGE } from "./Image";
import { reactLocalStorage } from "reactjs-localstorage";
import { get_mesas } from "./Services";
export default function PantallaMesas(props) {
  const {
    dataMesas = [],
    dataCategoria = [],
    dataItems = [],
    dataOrdenesDetalle = [],
    formRestaurante,
    isResEditing,
    enableTab,
    usr_precio,
    usr_perfil,
    subtotal,
    itbms,
    total,
    setFormRestaurante,
    setFormFactura,
    fetchOrdenes,
    addItemRestaurante,
    onClickEntregarOrden,
    onClickGuardarOrdenRestaurante,
    deleteRowRestaurant,
    handleSaveRowRestaurante,
    DATATABLE_RESTAURANTE,
    imgURLocalImage,
    LOGO_RESTAURANTE,
    dataCompania,
    quitToken,
    printrecibo_cocina,
    onChangeNumberOrden,
    guardarNombreMesa,
    onClickOpenPagar,
    onClickSaveFacturaPr,
    descuento,
    deleteOrdenMesa,
    fetchReportX,
    setModalCopiaF,
    fetchListFacImprimir,
  } = props;
  const { setdataFacturaLocalStorage } = useContext(StoreContext);
  const [editarMesaSeleccionada, setEditarMesaSeleccionada] = useState(false);
  const [nombreMesaSeleccionada, setNombreMesaSeleccionada] = useState("");
  const [isOpenMesasDiv, SetOpenMesasDiv] = useState(false);
  const [now, setNow] = useState(Date.now());
  const [dataRestaurante, setDataRestaurante] = useState([]);
  const [search, setSearch] = useState("");

  async function fetchMesas() {
    var response = await get_mesas();
    const mesasActivas = response.filter((mesa) => mesa.res_active === "1");
    setDataRestaurante(mesasActivas);
  }

  useEffect(() => {
    fetchMesas();
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const getMesaStatus = (res_id) => {
    const orden = dataMesas.find((m) => m.ord_mesa === res_id);
    if (!orden) return "free";
    return orden.ordd_entregado === "1" ? "ready" : "cook";
  };

  function formatElapsed(ms) {
    const totalSec = Math.max(0, Math.floor(ms / 1000));
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  function getTimeOrden(res_id) {
    const orden = dataMesas.find((data) => String(data.ord_mesa) === String(res_id));
    if (!orden?.ord_fecha) return null;
    const fecha = new Date(orden.ord_fecha).getTime();
    if (Number.isNaN(fecha)) return null;
    const elapsedMs = now - fecha;
    if (elapsedMs < 0 || elapsedMs >= 86400000) return null;
    return formatElapsed(elapsedMs);
  }

  const getMesaOrden = (res_id) => {
    const orden = dataMesas.find((m) => m.ord_mesa === res_id);
    if (!orden) return null;
    const id = orden.ord_identificador || orden.ordd_identificador || orden.identificador || "";
    const s = String(id);
    return s ? s.slice(-4) : null;
  };

  const hasMesa = formRestaurante.res_mesa_selected.length > 0;

  const updateUsrIdLocal = (usr_perfil) => {
    const tokenActual = reactLocalStorage.getObject("tokenP");
    reactLocalStorage.setObject("tokenP", { ...tokenActual, usr_perfil });
    window.location.reload();
  };
  const existeComandaNueva = dataOrdenesDetalle.some((item) => item.ordd_comanda === "0");

  const [areaSelected, setAreaSelected] = useState("");
  /* =========================================================
   ÁREAS DEL RESTAURANTE
========================================================= */

  const areasRestaurante = useMemo(() => {
    const areas = new Map();

    dataRestaurante.forEach((mesa) => {
      const id = String(mesa.ar_id || "");

      if (id === "") {
        return;
      }

      if (!areas.has(id)) {
        areas.set(id, {
          ar_id: id,
          ar_desc: mesa.ar_desc || `Área ${id}`,
        });
      }
    });

    return Array.from(areas.values());
  }, [dataRestaurante]);

  /* =========================================================
   SELECCIONAR PRIMERA ÁREA AUTOMÁTICAMENTE
========================================================= */

  useEffect(() => {
    if (areasRestaurante.length === 0) {
      return;
    }

    const existeArea = areasRestaurante.some((area) => String(area.ar_id) === String(areaSelected));

    if (areaSelected === "" || !existeArea) {
      setAreaSelected(areasRestaurante[0].ar_id);
    }
  }, [areasRestaurante, areaSelected]);

  /* =========================================================
   MESAS DEL ÁREA SELECCIONADA
========================================================= */

  const mesasArea = useMemo(() => {
    if (areaSelected === "") {
      return [];
    }

    return dataRestaurante.filter((mesa) => String(mesa.ar_id) === String(areaSelected));
  }, [dataRestaurante, areaSelected]);
  const totalMesas = mesasArea.length;

  const mesasLibres = mesasArea.filter((d) => getMesaStatus(d.res_id) === "free").length;
  return (
    <div className="rt-pos">
      <header className="rt-topbar">
        <Row className="rt-topbar-row g-0 w-100">
          {/* MARCA */}
          <Col xs={12} md={2} className="rt-brand">
            <span className="rt-brand-icon">
              <img src={LOGO_RESTAURANTE} alt={dataCompania.com_nombre} />
            </span>

            <div className="rt-brand-text">
              <h1 className="rt-brand-title">{dataCompania.com_nombre}</h1>

              <p className="rt-brand-sub">Toma de órdenes</p>
            </div>
          </Col>

          {/* DERECHA */}
          <Col xs={12} md={10} className="rt-header-right">
            <div className="rt-toolbar">
              {/* ÁREAS */}
              <nav className="rt-area-nav" aria-label="Áreas del restaurante">
                <div className="rt-header-areas">
                  {areasRestaurante.map((area) => {
                    const active = String(areaSelected) === String(area.ar_id);

                    return (
                      <button key={area.ar_id} type="button" aria-pressed={active} className={`rt-area-btn ${active ? "is-active" : ""}`} onClick={() => setAreaSelected(area.ar_id)}>
                        {area.ar_desc}
                      </button>
                    );
                  })}
                </div>
              </nav>

              <div className="rt-toolbar-tools">
                {/* LEYENDA */}
                <div className="rt-legend rt-legend--top" aria-label="Estado de las mesas">
                  <span className="rt-legend-item">
                    <i className="rt-dot free" />
                    Libre
                  </span>

                  <span className="rt-legend-item">
                    <i className="rt-dot cook" />
                    En cocina
                  </span>

                  <span className="rt-legend-item">
                    <i className="rt-dot ready" />
                    Listo
                  </span>
                </div>

                <div className="rt-header-divider" aria-hidden="true" />

                {/* ACCIONES */}
                <div className="rt-header-actions">
                  <button type="button" className="rt-action-btn" title="Generar informe diario" onClick={fetchReportX}>
                    Informe diario
                  </button>

                  <button
                    type="button"
                    className="rt-action-btn"
                    title="Ver facturas"
                    onClick={() => {
                      setModalCopiaF(true);
                      fetchListFacImprimir();
                    }}
                  >
                    Facturas
                  </button>

                  <IconButton
                    className="rt-header-action"
                    title="Actualizar"
                    aria-label="Actualizar"
                    onClick={() => {
                      setdataFacturaLocalStorage({
                        dataFacturaDetallePr: [],
                      });

                      window.location.reload();
                    }}
                  >
                    <ReloadIcon />
                  </IconButton>

                  <IconButton className="rt-header-action rt-header-exit" title="Salir" aria-label="Salir" onClick={quitToken}>
                    <img src={EXIT_IMAGE} className="rt-exit-image" alt="" />
                  </IconButton>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </header>
      {!isOpenMesasDiv ? (
        <section className="rt-card rt-card-mesas" onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
          <div className="rt-card-head" onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
            <h6 className="rt-card-title">Seleccionar mesa</h6>
            <div className="rt-mesa-selected">
              <span>{formRestaurante.res_nombre || "Sin mesa seleccionada"}</span>
              <IconButton
                className="rt-mesa-expand-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  SetOpenMesasDiv(!isOpenMesasDiv);
                }}
              >
                <AmpliarDiv />
              </IconButton>
            </div>
            <div className="rt-mesas-count-box">
              <MDBIcon fas icon="users" />
              <span>
                <strong>{mesasLibres}</strong> libres · {totalMesas} en total
              </span>
            </div>
          </div>
          <div className="rt-mesas">
            {mesasArea.map((data, i) => {
              const status = getMesaStatus(data.res_id);
              var time = getTimeOrden(data.res_id);
              const ordenNum = getMesaOrden(data.res_id);
              const selected = formRestaurante.res_mesa_selected === data.res_id;
              var name_nuevo = "";
              dataMesas.map((val) => {
                if (val.ord_mesa === data.res_id) {
                  name_nuevo = " - " + val.ord_nombre_mesa;
                }
              });
              const label = status === "free" ? "Libre" : ordenNum ? `Orden ${ordenNum}` : status === "cook" ? "En cocina" : "Listo";
              return (
                <button
                  key={i}
                  className={`rt-mesa ${status} ${selected ? "selected" : ""}`}
                  aria-pressed={selected}
                  onClick={() => {
                    const primeraCategoria = dataCategoria[0];
                    fetchOrdenes({
                      res_id: data.res_id,
                      form: {
                        res_mesa_selected: data.res_id,
                        res_mesa_id: data.res_id,
                        res_nombre: data.res_nombre,
                        res_categoria_selected: primeraCategoria ? primeraCategoria.cat_descripcion : "",
                        res_categoria_id: primeraCategoria ? primeraCategoria.art_categoria : "",
                      },
                    });
                    setSearch("");
                    setFormFactura({
                      res_mesa_selected: data.res_id,
                      res_mesa_id: data.res_id,
                      res_nombre: data.res_nombre,
                      res_categoria_selected: primeraCategoria ? primeraCategoria.cat_descripcion : "",
                      res_categoria_id: primeraCategoria ? primeraCategoria.art_categoria : "",
                    });
                  }}
                >
                  <div className="rt-mesa-top">
                    <span className="rt-mesa-name">{data.res_nombre + name_nuevo}</span>
                    <span className={`rt-mesa-icon ${status}`}>{status === "cook" ? <IconChef /> : status === "ready" ? <IconUtensils /> : <span className="rt-mesa-freedot" />}</span>
                    {time !== null && (
                      <div className="d-flex">
                        <div className="time-clock">
                          <IconClock />
                        </div>
                        {time}
                      </div>
                    )}
                  </div>
                  <div className="rt-mesa-label">
                    {status !== "free" && <IconCheck />}
                    {label}
                  </div>
                </button>
              );
            })}
          </div>
        </section>
      ) : (
        <section className="rt-card rt-card-mesas-hidden rt-mesas-select-card" onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
          <Row className="align-items-center g-2">
            <Col xs={6}>
              <div className="rt-mesas-select-info">
                <div className="rt-mesas-select-icon">
                  <MDBIcon fas icon="chair" />
                </div>
                <div>
                  <h6 className="rt-card-title mb-1">Seleccionar mesa</h6>
                  <span className="rt-mesas-subtitle">Elige una mesa para comenzar a tomar la orden</span>
                </div>
              </div>
            </Col>

            <Col xs={6}>
              <div className="rt-mesas-select-actions">
                <div className="rt-mesa-selected" onClick={(e) => e.stopPropagation()}>
                  {editarMesaSeleccionada ? (
                    <input type="text" className="rt-mesa-selected-input" value={nombreMesaSeleccionada} autoFocus onChange={(e) => setNombreMesaSeleccionada(e.target.value)} />
                  ) : (
                    <span>{formRestaurante.res_nombre + (formRestaurante.ord_nombre_mesa !== undefined ? " - " + formRestaurante.ord_nombre_mesa : "Sin mesa seleccionada") || "Sin mesa seleccionada"}</span>
                  )}
                  {formRestaurante.current_ord_identificador.length > 0 ? (
                    <>
                      {" "}
                      {formRestaurante.res_mesa_id && (
                        <IconButton
                          className="rt-mesa-edit-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (editarMesaSeleccionada) {
                              guardarNombreMesa({ ordd_identificador: formRestaurante.current_ord_identificador, ord_nombre_mesa: nombreMesaSeleccionada });
                              setFormRestaurante({ ...formRestaurante, res_nombre: nombreMesaSeleccionada });
                              setEditarMesaSeleccionada(false);
                            } else {
                              setNombreMesaSeleccionada(formRestaurante.res_nombre || "");
                              setEditarMesaSeleccionada(true);
                            }
                          }}
                        >
                          <MDBIcon fas icon={editarMesaSeleccionada ? "save" : "pen"} />
                        </IconButton>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {!editarMesaSeleccionada && (
                    <IconButton
                      className="rt-mesa-expand-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        SetOpenMesasDiv(!isOpenMesasDiv);
                      }}
                    >
                      <AmpliarDiv />
                    </IconButton>
                  )}
                </div>
                <div className="rt-mesas-count-box">
                  <MDBIcon fas icon="users" />
                  <span>
                    <strong>{mesasLibres}</strong> libres · {totalMesas} en total
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      )}
      {hasMesa ? (
        <div className="rt-workspace">
          <div className={!isOpenMesasDiv ? "rt-card rt-menu-card" : "rt-card rt-menu-card2"}>
            <div className="rt-menu-head">
              <label className="rt-search-wrap">
                <span className="rt-search-icon">
                  <IconSearch />
                </span>
                <input id="search" name="search" type="text" className="rt-search" placeholder="Filtrar productos…" value={search} onChange={handleChange} />
                <span className="rt-sr-only">Filtrar productos del menú</span>
              </label>
            </div>
            <div className="rt-menu">
              <div className="rt-menu-categorias">
                <div className="rt-menu-header">
                  <h5 className="rt-menu-title">Menú</h5>
                  <span className="rt-menu-subtitle">Categorías</span>
                </div>

                <nav className="rt-cats" aria-label="Categorías del menú">
                  {dataCategoria.map((data, a) => {
                    const active = formRestaurante.res_categoria_id === data.art_categoria;

                    return (
                      <button
                        key={a}
                        type="button"
                        className={`rt-cat ${active ? "active" : ""}`}
                        aria-current={active ? "true" : undefined}
                        onClick={() => {
                          setSearch("");
                          setFormRestaurante({
                            ...formRestaurante,
                            res_categoria_selected: data.cat_descripcion,
                            res_categoria_id: data.art_categoria,
                          });
                        }}
                      >
                        <span className="rt-cat-name">{data.cat_descripcion}</span>
                        <span className="rt-cat-arrow" aria-hidden="true">
                          ›
                        </span>
                      </button>
                    );
                  })}
                </nav>
              </div>

              <div className="rt-items">
                {dataItems.map((data, a) => {
                  const hayBusqueda = search.trim() !== "";
                  const coincideBusqueda = data.art_descripcion.toUpperCase().includes(search.trim().toUpperCase());
                  const perteneceCategoria = data.art_categoria === formRestaurante.res_categoria_id;
                  const mostrar = hayBusqueda ? coincideBusqueda : perteneceCategoria;

                  if (!mostrar) {
                    return null;
                  }

                  return (
                    <button key={a} className="rt-item" onClick={() => addItemRestaurante(data)}>
                      <img loading="lazy" decoding="async" className="rt-item-img" alt={data.art_descripcion} src={data.art_imgName && data.art_imgName.trim() !== "" ? imgURLocalImage + data.art_imgName : COCINA_DEFAULT} />

                      <div className="rt-item-info">
                        <h6 className="rt-item-name">{data.art_descripcion.toUpperCase()}</h6>

                        <span className="rt-item-price">{"B/. " + data.art_precio}</span>
                      </div>

                      <span className="rt-item-add" aria-hidden="true">
                        +
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="rt-ticket">
            <div className="rt-ticket-head">
              <div className="rt-ticket-id">
                <span className="rt-ticket-icon">
                  <IconReceipt />
                </span>
                <div>
                  <p className="rt-ticket-mesa">{formRestaurante.res_nombre || "Sin mesa selecionada"}</p>
                  <p className="rt-ticket-orden">Orden #{formRestaurante.current_ord_identificador.slice(-4)}</p>
                </div>
              </div>
              <span className="rt-ticket-count">{dataOrdenesDetalle.length} ítems</span>
            </div>

            <div className="rt-ticket-body">
              <DATATABLE_RESTAURANTE deleteRow={deleteRowRestaurant} handleSaveRow={handleSaveRowRestaurante} dataOrdenes={dataOrdenesDetalle} enableTab={enableTab} usr_precio={usr_precio} isRestaurant={true} isEditing={isResEditing} ordd_entregado={isResEditing} isOpenMesasDiv={isOpenMesasDiv} />
            </div>

            <div className="rt-ticket-foot">
              <FOOTER_FACTURA_RESTAURANTE enableTab={enableTab} subtotal={subtotal} itbms={itbms} total={total - descuento} usr_perfil={usr_perfil} />

              <div className="rt-actions-mobile">
                {dataOrdenesDetalle[0] !== undefined && isResEditing === false ? (
                  <>
                    <Row className="mb-2">
                      <Col xs={12}>
                        <input id="ord_info_comanda" name="ord_info_comanda" type="text" className="rt-info-comanda w-100" placeholder="Información en la comanda" value={formRestaurante.ord_info_comanda || ""} onChange={onChangeNumberOrden} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={4}>
                        <label className="rt-para-llevar w-100">
                          <input
                            type="checkbox"
                            checked={formRestaurante.ord_para_llevar === "1"}
                            onChange={(e) =>
                              setFormRestaurante({
                                ...formRestaurante,
                                ord_para_llevar: e.target.checked ? "1" : "0",
                              })
                            }
                          />
                          <span>Llevar</span>
                        </label>
                      </Col>
                      <Col xs={4}>
                        <button
                          className="rt-btn cocina"
                          onClick={() => {
                            if (dataOrdenesDetalle[0] !== undefined) {
                              onClickGuardarOrdenRestaurante({ is_saving: true });
                            }
                          }}
                        >
                          <SaveIcon /> GUARDAR
                        </button>
                      </Col>
                      <Col xs={4}>
                        <button
                          className="rt-btn cocina"
                          onClick={() => {
                            if (dataOrdenesDetalle[0] !== undefined) {
                              onClickGuardarOrdenRestaurante({ is_saving: false });
                              printrecibo_cocina({ flag_comanda: false });
                            }
                          }}
                        >
                          <IconChef /> COMANDA
                        </button>
                      </Col>
                    </Row>
                  </>
                ) : null}

                {hasMesa && dataOrdenesDetalle[0] !== undefined && isResEditing && formRestaurante.ordd_entregado === "0" ? (
                  <>
                    {!existeComandaNueva && (
                      <Row className="align-items-end g-2 w-100 m-0">
                        <Col className="ps-0" xs={12}>
                          <label htmlFor="ord_info_comanda" className="rt-info-comanda-label">
                            Información en la comanda
                          </label>

                          <input id="ord_info_comanda" name="ord_info_comanda" type="text" className="rt-info-comanda" placeholder="Ej: Llevar todo junto..." value={formRestaurante.ord_info_comanda} disabled={true} />
                        </Col>
                        <Col xs={6}>
                          <label className="rt-para-llevar w-100">
                            <input type="checkbox" checked={formRestaurante.ord_para_llevar === "1"} disabled={true} />
                            <span>Para llevar</span>
                          </label>
                        </Col>
                        <Col xs={6} className="pe-0">
                          <button className="rt-btn entregar" onClick={() => (dataOrdenesDetalle[0] !== undefined ? onClickEntregarOrden() : null)}>
                            <IconUtensils /> Entregar
                          </button>
                        </Col>
                      </Row>
                    )}
                    {existeComandaNueva && (
                      <>
                        <Row className="mb-2">
                          <Col xs={12}>
                            <input id="ord_info_comanda" name="ord_info_comanda" type="text" className="rt-info-comanda w-100" placeholder="Información en la comanda" value={formRestaurante.ord_info_comanda || ""} onChange={onChangeNumberOrden} />
                          </Col>
                        </Row>
                        <Row className="g-2 align-items-stretch">
                          <Col xs={6}>
                            <label className="rt-para-llevar w-100">
                              <input
                                type="checkbox"
                                checked={formRestaurante.ord_para_llevar === "1"}
                                onChange={(e) =>
                                  setFormRestaurante({
                                    ...formRestaurante,
                                    ord_para_llevar: e.target.checked ? "1" : "0",
                                  })
                                }
                              />
                              <span>Para llevar</span>
                            </label>
                          </Col>
                          <Col xs={6}>
                            <button
                              className="rt-btn cocina"
                              onClick={() => {
                                if (dataOrdenesDetalle[0] !== undefined) {
                                  printrecibo_cocina({
                                    flag_comanda: true,
                                  });
                                }
                              }}
                            >
                              <IconChef /> COMANDA
                            </button>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                ) : null}
              </div>
              {
                <Row className="d-flex g-2 mt-1">
                  <Col xs={4}>
                    <button
                      className="rt-btn cocina"
                      disabled={dataOrdenesDetalle[0] !== undefined ? false : true}
                      onClick={() => {
                        if (dataOrdenesDetalle[0] !== undefined) {
                          deleteOrdenMesa({
                            ord_identificador: formRestaurante.current_ord_identificador,
                          });
                        }
                      }}
                    >
                      <Trash2Icon /> LIMPIAR MESA
                    </button>
                  </Col>
                  <Col xs={4}>
                    <button
                      type="button"
                      className="rt-btn cobrar"
                      disabled={dataOrdenesDetalle[0] === undefined}
                      onClick={() => {
                        if (dataOrdenesDetalle[0] !== undefined) {
                          onClickOpenPagar();
                        }
                      }}
                    >
                      <MDBIcon fas icon="cash-register" />
                      <span>COBRAR</span>
                    </button>
                  </Col>
                  <Col xs={4}>
                    <button
                      type="button"
                      className="rt-btn cobrar"
                      disabled={dataOrdenesDetalle[0] === undefined}
                      onClick={() => {
                        if (dataOrdenesDetalle[0] !== undefined) {
                          onClickSaveFacturaPr({ tipo: "0", pdf: false, prefactura: true });
                        }
                      }}
                    >
                      <MDBIcon fas icon="cash-register" />
                      <span>PREFACTURA</span>
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        </div>
      ) : (
        <div className="rt-empty">
          <img src={LOGO_RESTAURANTE || "/placeholder.svg"} alt="Restaurante" />
          <p>Selecciona una mesa para comenzar una orden</p>
        </div>
      )}
    </div>
  );
}
